import script from "./ModalInfoAddNewTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInfoAddNewTask.vue?vue&type=script&setup=true&lang=js"

import "./ModalInfoAddNewTask.vue?vue&type=style&index=0&id=225f0cb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225f0cb2"]])

export default __exports__